<app-alert></app-alert>
<ul class="breadcrumb" *ngIf="environmentSettings.PSS">
    <li>
        <a [routerLink]="['/']">Home</a>
    </li>
    <li>
        <a [routerLink]="['/KMP']">KMP</a>
    </li>
    <li>{{FirstName}} {{LastName}}</li>
</ul>
<section class="card">
    <div class="card-header">
        <div class="text-center">
            <span class="cat__core__title">
                <strong>Register of Key Managireal Person and their Shareholding.</strong>
                <h5>
                    <strong>[Pursuant to section 170 of the Companies Act, 2013 and rule 17 of the Companies (Appointment and Qualification
                        of Directors) Rules, 2014]</strong>
                </h5>
            </span>
            <span class="btnBackContainer">
                <a routerLink="/KMP">
                    <button class="btn btn-sm btn-default pull-right btn-back" type="button">
                        <i class=" fa fa-chevron-circle-left"></i>Back
                    </button>
                </a>
            </span>
            <div class="clearfix"></div>
        </div>
    </div>

    <div class="card-header sub-header-section">
        <div class="text-left">
            <span class="cat__core__title">
                <h5>
                    <strong>Name of the company:</strong>
                    <small>{{CompanyName}}</small>
                </h5>
            </span>
            <span class="cat__core__title">
                <h5>
                    <strong>CIN:</strong>
                    <small>{{CIN}}</small>
                </h5>
            </span>
            <span class="cat__core__title">
                <h5>
                    <strong>Registered office address:</strong>
                    <small>{{registerOfficeAddress}}</small>
                </h5>
            </span>
        </div>
    </div>

    <div class="card-block datatable-card-block">
        <div class="modal-content">
            <div class="modal-body">
                <div class="row">
                    <div class="col-md-3">
                        <label class="form-control-label fontweight">Director Identification Number:</label>
                    </div>
                    <div class="col-md-3">
                        <label class="form-control-label">{{DinNumber}}</label>
                    </div>
                    <div class="col-md-3">
                        <label class="form-control-label fontweight">Nationality (including the nationality of origin, if different):</label>
                    </div>
                    <div class="col-md-3">
                        <label class="form-control-label">{{Nationality}}</label>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-3">
                        <label class="form-control-label fontweight">Present name and surname in full:</label>
                    </div>
                    <div class="col-md-3">
                        <label class="form-control-label">{{FirstName}} {{MiddleName}} {{LastName}}</label>
                    </div>
                    <div class="col-md-3">
                        <label class="form-control-label fontweight">Occupation</label>
                    </div>
                    <div class="col-md-3">
                        <label class="form-control-label">{{Occupation}}</label>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-3">
                        <label class="form-control-label fontweight">Any former name or surname in full:</label>
                    </div>
                    <div class="col-md-3">
                        <label class="form-control-label">{{FirstName}} {{MiddleName}} {{LastName}}</label>
                    </div>
                    <div class="col-md-3">
                        <label class="form-control-label fontweight">Date of the board resolution in which the appointment was made:</label>
                    </div>
                    <div class="col-md-3">
                        <label class="form-control-label">{{BoardResolutionDate}}</label>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-3">
                        <label class="form-control-label fontweight">Father's Name:</label>
                    </div>
                    <div class="col-md-3">
                        <label class="form-control-label">{{FatherFirstName}} {{FatherMiddleName}} {{FatherLastName}}</label>
                    </div>
                    <div class="col-md-3">
                        <label class="form-control-label fontweight">Mother's Name:</label>
                    </div>
                    <div class="col-md-3">
                        <label class="form-control-label">{{MotherFirstName}} {{MotherMiddleName}} {{MotherLastName}}</label>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-3">
                        <label class="form-control-label fontweight">Date of appointment in the company:</label>
                    </div>
                    <div class="col-md-3">
                        <label class="form-control-label">{{AppointmentDate}}</label>
                    </div>
                    <div class="col-md-3">
                        <label class="form-control-label fontweight">Date of re-appointment in the company:</label>
                    </div>
                    <div class="col-md-3">
                        <label class="form-control-label">{{ReAppointmentDate}}</label>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-3">
                        <label class="form-control-label fontweight">Date of cessation of office:</label>
                    </div>
                    <div class="col-md-3">
                        <label class="form-control-label">{{CessationDate}}</label>
                    </div>                   
                    <div class="col-md-3">
                        <label class="form-control-label fontweight">Date of birth:</label>
                    </div>
                    <div class="col-md-3">
                        <label class="form-control-label">{{BirthDate}}</label>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-3">
                        <label class="form-control-label fontweight">Spouse's Name (If married):</label>
                    </div>
                    <div class="col-md-3">
                        <label class="form-control-label">{{SpouseFirstName}} {{SpouseMiddleName}} {{SpouseLastName}}</label>
                    </div>                  
                </div>
                <div class="row">
                    <div class="col-md-3">
                        <label class="form-control-label fontweight">Residential address:</label>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-3">
                        <label class="form-control-label fontweight">Present:</label>
                    </div>
                    <div class="col-md-3">
                        <label class="form-control-label">{{present}}</label>
                    </div>
                    <div class="col-md-3">
                        <label class="form-control-label fontweight">Permanent:</label>
                    </div>
                    <div class="col-md-3">
                        <label class="form-control-label">{{Permanent}}</label>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="card-header borderTop sub-header-section">
        <span class="cat__core__title">
            <strong>Office of director or KMP held or relinquished in any other body corporate:</strong>
        </span>
    </div>
    <div class="card-block datatable-card-block">
        <div class="row">
            <div class="col-md-12">
                <div class="margin-bottom-50">
                    <div [hidden]="hidekmpshipauthtable" class="table-responsive">
                        <table datatable [dtOptions]="dtOptionsOfUnauthorizekmpship" [dtTrigger]="dtTriggerUnauthorizekmpship" class="table table-hover compact cell-border nowrap stripe" id="authorizekmpshiptable"
                            style="cursor: pointer;">
                            <thead>
                                <tr>
                                    <th>
                                        <div class="md-checkbox">
                                            <input id="chkAuthorizekmpshiptableSelectAll" type="checkbox" [(ngModel)]="selectedAll" (change)="selectAll();" />
                                            <label for="chkAuthorizekmpshiptableSelectAll">&nbsp;</label>
                                        </div>
                                    </th>
                                    <th>Name of Company in which office held</th>
                                    <th>Type of Company</th>
                                    <th>Date of Appointment</th>
                                    <th>Designation held</th>
                                    <th>Date of Cessation/relinquishment</th>
                                    <th>Remarks</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let unauthorize of unauthorizeKmpshipsList;let i = index">
                                    <td>
                                        <div class="md-checkbox">
                                            <input id="chkAuthorizekmpshiptableSelectAll_{{i}}" type="checkbox" [(ngModel)]="unauthorize.SelectedKmpship" (change)="checkselected($event);"
                                                (change)="checkIfAllSelected();">
                                            <label for="chkAuthorizekmpshiptableSelectAll_{{i}}">&nbsp;</label>
                                        </div>
                                    </td>
                                    <td>{{unauthorize.OfficeName}}</td>
                                    <td>{{unauthorize.OfficeType}}</td>
                                    <td>{{unauthorize.AppointmentDate | date:"dd-MM-y"}}</td>
                                    <td>{{unauthorize.Designation}}</td>
                                    <td>{{unauthorize.CessationDate | date:"dd-MM-y"}}</td>
                                    <td>
                                           
                                        <input type="text"   [(ngModel)]="unauthorize.Remarks" class="form-control" style="width: 90%;">
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div [hidden]="hidekmpshiprectify" class="table-responsive">
                        <table datatable [dtOptions]="dtOptionsOfUnerectifiedKmpship" [dtTrigger]="dtTriggerUnerectifiedKmpship" class="table table-hover compact cell-border nowrap stripe" id="rectifykmptable"
                            style="cursor: pointer;">
                            <thead>
                                <tr>
                                    <th>
                                        <div class="md-checkbox">
                                            <input id="chkRectifykmptableSelectAll" type="checkbox" [(ngModel)]="selectedAllKmpship" (change)="selectAllKmpshipToRectify();"
                                            />
                                            <label for="chkRectifykmptableSelectAll">&nbsp;</label>
                                        </div>
                                    </th>
                                    <th>Name of Company in which office held</th>
                                    <th>Type of Company</th>
                                    <th>Date of Appointment</th>
                                    <th>Designation held</th>
                                    <th>Date of Cessation/relinquishment</th>
                                    <th>Remarks</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let unrectify of unRectifiedKmpshipsList;let i = index">
                                    <td>
                                        <div class="md-checkbox">
                                            <input id="chkRectifykmptableSelectAll_{{i}}" type="checkbox" [(ngModel)]="unrectify.SelectedKmpship" (change)="checkrectifyselected($event);"
                                                (change)="checkIfAllKmpshipSelected();">
                                            <label for="chkRectifykmptableSelectAll_{{i}}">&nbsp;</label>
                                        </div>
                                    </td>
                                    <td>{{unrectify.OfficeName}}</td>
                                    <td>{{unrectify.OfficeType}}</td>
                                    <td>{{unrectify.AppointmentDate | date:"dd-MM-y"}}</td>
                                    <td>{{unrectify.Designation}}</td>
                                    <td>{{unrectify.CessationDate | date:"dd-MM-y"}}</td>
                                    <td>
                                        <input type="text"   [(ngModel)]="unrectify.Remarks"  class="form-control" style="width: 90%;">
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade" id="messagePopUp" tabindex="-1" role="dialog" aria-labelledby="" aria-hidden="true" style="top: 50px;">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div id="alertTitle" class="modal-header" style="font-size: 20px; font-weight: bold; padding: 5px 15px;">
                        Title!
                    </div>
                    <div class="modal-body">
                        <div id="alertMessage">
                            Message..
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="card-header borderTop sub-header-section">
        <span class="cat__core__title">
            <strong>Details of securities held in the Company, its holding company, subsidiaries, subsidiaries of the companys holding
                company and associate companies:</strong>
        </span>
    </div>
    <div class="card-block datatable-card-block">
        <div class="row">
            <div class="col-md-12">
                <div class="margin-bottom-50">
                    <div class="table-responsive" [hidden]="hidesubkmpauthtable">
                        <table datatable [dtOptions]="dtOptionsOfUnauthorizeSubkmp" [dtTrigger]="dtTriggerUnauthorizeSubkmp" class="table table-hover compact cell-border nowrap stripe" id="authorizeSubkmptable"
                            style="cursor: pointer;">
                            <thead>
                                <tr>
                                    <th>
                                        <div class="md-checkbox">
                                            <input id="chkAuthorizeSubkmptableSelectAll" type="checkbox" [(ngModel)]="allSelected" (change)="allSelect();" />
                                            <label for="chkAuthorizeSubkmptableSelectAll">&nbsp;</label>
                                        </div>
                                    </th>
                                    <th>Name of the Company</th>
                                    <th>Number of Securities</th>
                                    <th>Description of Securities</th>
                                    <th>Nominal Value of Securities</th>
                                    <th>Date of Acquisition</th>
                                    <th>Price paid for acquisition of securities</th>
                                    <th>Other consideration paid for acquisition</th>
                                    <th>Date of disposal</th>
                                    <th>Number of shares disposed</th>
                                    <th>Price received on disposal</th>
                                    <th>Other consideration received on disposal</th>
                                    <th>Cumulative balance and number of securities held after each transaction</th>
                                    <th>Mode of acquisition of securities</th>
                                    <th>Mode of holding physical or dematerialized form</th>
                                    <th>Securities have been pledged or any encumbrance has been created</th>
                                    <th>Remarks</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let unauthorize of unauthorizeSubkmpList;let i = index">
                                    <td>
                                        <div class="md-checkbox">
                                            <input id="chkAuthorizeSubkmptableSelectAll_{{i}}" type="checkbox" [(ngModel)]="unauthorize.SelectedSubkmp" (change)="checkselected($event);"
                                                (change)="checksubIfAllSelected();">
                                            <!-- <input id="chkAuthorizeSubkmptableSelectAll" type="checkbox" [(ngModel)]="allSelected"
                                                (change)="allSelect();" /> -->
                                            <label for="chkAuthorizeSubkmptableSelectAll_{{i}}">&nbsp;</label>
                                        </div>
                                    </td>
                                    <td>{{unauthorize.CompanyName}}</td>
                                    <td>{{unauthorize.NumberOfSecurities}}</td>
                                    <td>{{unauthorize.SecurityDescription}}</td>
                                    <td>{{unauthorize.SecurityNominalValue}}</td>
                                    <td>{{unauthorize.AcquisitionDate | date:"dd-MM-y"}}</td>
                                    <td>{{unauthorize.AcquisitionPaidPrize}}</td>
                                    <td>{{unauthorize.AcquisitionOtherPrize}}</td>
                                    <td>{{unauthorize.DisposalDate| date:"dd-MM-y"}}</td>
                                    <td>{{unauthorize.NumberOfSharesDisposed}}</td>
                                    <td>{{unauthorize.DisposalPrize}}</td>
                                    <td>{{unauthorize.DisposalReceivedPrize}}</td>
                                    <td>{{unauthorize.CumulativePrize}}</td>
                                    <td>{{unauthorize.AcquisitionSecuritiesMode}}</td>
                                    <td>{{unauthorize.HoldingMode}}</td>
                                    <td>{{unauthorize.PledgedSecurities}}</td>
                                    <td>
                                       
                                        <input type="text"   [(ngModel)]="unauthorize.Remarks"  class="form-control" style="width: 85%;">
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="table-responsive" [hidden]="hidesubkmprectify">
                        <table datatable [dtOptions]="dtOptionsOfUnrectifiedSubkmp" [dtTrigger]="dtTriggerUnrectifiedSubkmp" class="table table-hover compact cell-border nowrap stripe" id="rectifySubkmptable"
                            style="cursor: pointer;">
                            <thead>
                                <tr>
                                    <th>
                                        <div class="md-checkbox">
                                            <input id="chkRectifySubkmptableSelectAll" type="checkbox" [(ngModel)]="allsubkmpselected" (change)="allSubkmpSelect();"
                                            />
                                            <label for="chkRectifySubkmptableSelectAll">&nbsp;</label>
                                        </div>
                                    </th>
                                    <th>Name of the Company</th>
                                    <th>Number of Securities</th>
                                    <th>Description of Securities</th>
                                    <th>Nominal Value of Securities</th>
                                    <th>Date of Acquisition</th>
                                    <th>Price paid for acquisition of securities</th>
                                    <th>Other consideration paid for acquisition</th>
                                    <th>Date of disposal</th>
                                    <th>Number of shares disposed</th>
                                    <th>Price received on disposal</th>
                                    <th>Other consideration received on disposal</th>
                                    <th>Cumulative balance and number of securities held after each transaction</th>
                                    <th>Mode of acquisition of securities</th>
                                    <th>Mode of holding physical or dematerialized form</th>
                                    <th>Securities have been pledged or any encumbrance has been created</th>
                                    <th>Remarks</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let unrectify of unRectifiedSubkmpList;let i = index">
                                    <td>
                                        <div class="md-checkbox">
                                            <input id="chkRectifySubkmptableSelectAll_{{i}}" type="checkbox" [(ngModel)]="unrectify.SelectedSubkmp" (change)="checkrectifyselected($event);"
                                                (change)="checksubrectifyIfAllSelected();">
                                            <label for="chkRectifySubkmptableSelectAll_{{i}}">&nbsp;</label>
                                        </div>
                                    </td>
                                    <td>{{unrectify.CompanyName}}</td>
                                    <td>{{unrectify.NumberOfSecurities}}</td>
                                    <td>{{unrectify.SecurityDescription}}</td>
                                    <td>{{unrectify.SecurityNominalValue}}</td>
                                    <td>{{unrectify.AcquisitionDate | date:"dd-MM-y"}}</td>
                                    <td>{{unrectify.AcquisitionPaidPrize}}</td>
                                    <td>{{unrectify.AcquisitionOtherPrize}}</td>
                                    <td>{{unrectify.DisposalDate}}</td>
                                    <td>{{unrectify.NumberOfSharesDisposed}}</td>
                                    <td>{{unrectify.DisposalPrize}}</td>
                                    <td>{{unrectify.DisposalReceivedPrize}}</td>
                                    <td>{{unrectify.CumulativePrize}}</td>
                                    <td>{{unrectify.AcquisitionSecuritiesMode}}</td>
                                    <td>{{unrectify.HoldingMode}}</td>
                                    <td>{{unrectify.PledgedSecurities}}</td>
                                    <td>
                                        <input type="text"  [(ngModel)]="unrectify.Remarks" class="form-control" style="width: 85%;">
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="messagePopUp" tabindex="-1" role="dialog" aria-labelledby="" aria-hidden="true" style="top: 50px;">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div id="alertTitle" class="modal-header" style="font-size: 20px; font-weight: bold; padding: 5px 15px;">
                        Title!
                    </div>
                    <div class="modal-body">
                        <div id="alertMessage">
                            Message..
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade" id="confirmation" tabindex="-1" role="dialog" aria-labelledby="" aria-hidden="true" style="top: 50px;">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="myModalLabelForDelete">
                            <i class="fa fa-question-circle-o mr-2"></i>Confirmation of Password</h5>
                        <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                            <i class="fa fa-times"></i>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-sm-12">
                                <div class="form-group">
                                    Enter Password
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12">
                                <div class="form-group">
                                    <input type="password" [(ngModel)]="password" [ngModelOptions]="{standalone: true}" class="form-control">
                                </div>
                            </div>
                        </div>
                        <!-- <div class="row">
                          <div class="col-sm-12">
                              <div class="form-group">
                                  <button type="button" class="btn btn-sm btn-primary" data-dismiss="modal" (click)="authorize()">Confirm</button>
                              </div>
                          </div>
                      </div> -->
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-sm btn-primary" data-dismiss="modal" (click)="checkPassword()">
                            <i class="fa fa-check"></i>Confirm
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <div class="col-md-2" [hidden]="hideauthorizebutton">
            <button id="btnauthorize" style="float: right" type="button" (click)="Confirmation()" [disabled]="!Isselected" class="btn btn-sm btn-primary">
                <i class="fa fa-lock"></i>Authorize
            </button>
        </div>
        <div class="col-md-2" [hidden]="hiderectifybutton">
            <button id="btnrectify" style="float: right" type="button" (click)="Confirmation()" [disabled]="!checkIsslected" class="btn btn-sm btn-primary">
                <i class="fa fa-unlock"></i>Rectify
            </button>
        </div>
    </div>
</section>